"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _UpsellCategoryDisplay = _interopRequireDefault(require("../Upsell/UpsellCategoryDisplay"));
var _UpsellBreakdown = _interopRequireDefault(require("../Upsell/UpsellBreakdown"));
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _useSetModalSize = require("../../hooks/app/useSetModalSize");
var _RecommendationFooter = _interopRequireDefault(require("./RecommendationFooter"));
var _UpsellBreakdownWrapper = _interopRequireDefault(require("../Upsell/UpsellBreakdownWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledGridRow = (0, _BaseComponents.GrayBackground)(_r10SourceLibrary.GridRow);
const UpsellSubPage = () => {
  (0, _useSetModalSize.useSetModalSizeByName)('upsell', 'recommendation');
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "upsell-subPge-id"
  }, /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_UpsellCategoryDisplay.default, null))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_UpsellBreakdownWrapper.default, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_UpsellBreakdown.default, null)))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_RecommendationFooter.default, null))));
};
var _default = UpsellSubPage;
exports.default = _default;